import { render, staticRenderFns } from "./TruckOrderViewModal.vue?vue&type=template&id=27d8d5a6"
import script from "./TruckOrderViewModal.vue?vue&type=script&lang=ts"
export * from "./TruckOrderViewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports